export class MainMenuType {
  id: number

  name: string

  runningNo: number
}
